/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_4_QInputs */

const en_mk_tut_tr_4_q = /** @type {(inputs: Mk_Tut_Tr_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent ignores a rule I told it about.`)
};

const id_mk_tut_tr_4_q = /** @type {(inputs: Mk_Tut_Tr_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasil agen mengabaikan aturan yang sudah saya beri tahu.`)
};

/**
* | output |
* | --- |
* | "The agent ignores a rule I told it about." |
*
* @param {Mk_Tut_Tr_4_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_4_q = /** @type {((inputs?: Mk_Tut_Tr_4_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_4_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_4_q(inputs)
	return en_mk_tut_tr_4_q(inputs)
});